import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

import { DropDownMultiCheck } from "../DropDownMultiCheck";
import IconDelete from "../../../../layout/others/icon-x.svg";

export default function CompetencesAndSkills({
  searchObject,
  t,
  setSearchObject
}) {
  const [technologies, setTechnologies] = useState([]);

  useEffect(() => {
    CommonService.getTechSkills().then((data) => setTechnologies(data));
  }, []);

  function setSelectedSkills(list) {
    setSearchObject({ ...searchObject, skills: list });
  }
  function onChange(e) {
    const { name, checked } = e.target;
    setSearchObject({ ...searchObject, [name]: checked });
  }
  function clearSkills() {
    let _searchObject = { ...searchObject };
    _searchObject.skills = [];
    _searchObject.allTechnologies = null;

    setSearchObject(_searchObject);
  }

  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Skills")}</legend>
        {searchObject.skills?.length !== 0 && (
          <button
            onClick={clearSkills}
            className="btn-clear-language-level position-clear-button"
          >
            <img src={IconDelete} alt="ico-ppl" height="12px" width="auto" />
          </button>
        )}

        <div className="row">
          <div className="col">
            {" "}
            <DropDownMultiCheck
              dataList={technologies}
              selecteds={searchObject.skills}
              setSelecteds={setSelectedSkills}
              autoCompleteMode={true}
            />
          </div>
          <div className="col-2">
            <div className="form-group mt-2">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  checked={searchObject.allTechnologies}
                  name="allTechnologies"
                  id="allTechnologies"
                  onChange={onChange}
                />

                <label className="form-label" for="recommended">
                  <span className="recommended-tab-button">{t("All")}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
